import { API } from "utils/api"

const FLEET_API_URL = process.env.REACT_APP_FLEET_API_URL
const FLEET_GOOGLE_AUTH_TOKEN = process.env.REACT_APP_FLEET_GOOGLE_AUTH_TOKEN

interface AuthTokenResponse {
	token: string
	expiresInSeconds: number
}

let tokenCache: { token: string; expiresAt: number } | null = null

export const clearTokenCache = () => {
	tokenCache = null
}

export const fleetAuthTokenFetcher = async (_options: {
	serviceType: string
}) => {
	const now = Date.now()
	if (tokenCache && tokenCache.expiresAt > now + 5 * 60 * 1000) {
		return {
			token: tokenCache.token,
			expirationTime: new Date(tokenCache.expiresAt),
		}
	}

	if (!FLEET_API_URL || !FLEET_GOOGLE_AUTH_TOKEN) {
		throw new Error("Fleet Engine API configuration is missing")
	}

	const response = await API.get({
		url: `${FLEET_API_URL}/auth/googleAccessToken`,
		headers: {
			"x-access-google-token": FLEET_GOOGLE_AUTH_TOKEN,
		},
	})

	if (!response.ok || !response.data?.token) {
		throw new Error("Failed to fetch auth token")
	}

	const { token, expiresInSeconds = 3600 } = response.data as AuthTokenResponse
	const expiresAt = now + expiresInSeconds * 1000

	tokenCache = { token, expiresAt }

	return {
		token,
		expirationTime: new Date(expiresAt),
	}
}
